import { render, staticRenderFns } from "./customerChurnRegionPage.vue?vue&type=template&id=210a0462&scoped=true&"
import script from "./customerChurnRegionPage.vue?vue&type=script&lang=js&"
export * from "./customerChurnRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./customerChurnRegionPage.vue?vue&type=style&index=0&id=210a0462&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a0462",
  null
  
)

export default component.exports